import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FieldsetModule } from 'primeng/fieldset';

@Component({
  selector: 's-ui-fieldset',
  templateUrl: './s-ui-fieldset.component.html',
  styleUrls: ['./s-ui-fieldset.component.scss'],
  standalone: true,

  imports: [FieldsetModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SUiFieldsetComponent implements OnInit {
  @Input() legend: string;
  @Input() toggleable: boolean;

  ngOnInit() {
    this.toggleable = this.toggleable || false;
  }
}
